import { ResponseError } from '@roadfootage/api-client'

// The API explains why it refused a request (too far, already claimed, not enough points) in the body:
// plain text, a JSON string, or problem details. Show that text rather than a generic failure.
// A validation problem (400) carries the readable reasons under `errors`, keyed by property; its title is generic.
function firstValidationMessage(errors: unknown): string | undefined {
  if (!errors || typeof errors !== 'object') return undefined
  for (const messages of Object.values(errors)) {
    const first = Array.isArray(messages) ? messages[0] : undefined
    if (typeof first === 'string' && first) return first
  }
  return undefined
}

export async function readApiErrorMessage(error: unknown, fallback: string): Promise<string> {
  if (!(error instanceof ResponseError)) return fallback
  let body: string
  try {
    body = (await error.response.text()).trim()
  } catch {
    return fallback
  }
  if (!body) return fallback
  try {
    const parsed = JSON.parse(body)
    if (typeof parsed === 'string') return parsed || fallback
    return firstValidationMessage(parsed?.errors) ?? parsed?.detail ?? parsed?.title ?? fallback
  } catch {
    return body
  }
}
